export default function ArrowRight() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7118 18.362C12.5243 18.1745 12.419 17.9201 12.419 17.6549C12.419 17.3897 12.5243 17.1353 12.7118 16.9478L16.6646 12.9951L4.93367 13.0021C4.66737 13.0021 4.41198 12.8964 4.22367 12.708C4.03537 12.5197 3.92958 12.2643 3.92958 11.998C3.92958 11.7317 4.03537 11.4764 4.22367 11.288C4.41198 11.0997 4.66737 10.994 4.93367 10.994L16.6646 11.001L12.7118 7.0483C12.5243 6.86076 12.419 6.60641 12.419 6.34119C12.419 6.07598 12.5243 5.82162 12.7118 5.63409C12.8994 5.44655 13.1537 5.34119 13.419 5.34119C13.6842 5.34119 13.9385 5.44655 14.1261 5.63409L19.7829 11.2909C19.9704 11.4785 20.0758 11.7328 20.0758 11.998C20.0758 12.2633 19.9704 12.5176 19.7829 12.7052L14.1261 18.362C13.9385 18.5495 13.6842 18.6549 13.419 18.6549C13.1537 18.6549 12.8994 18.5495 12.7118 18.362Z"
        fill="#808285"
      />
    </svg>
  );
}
